module.exports = __webpack_public_path__ + "static/trailer-5ee5c5d738c9c91ebafbbc8f938598c2.mp4";